import { useState, useEffect, useRef, useMemo } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxTitle,
  BoxContainer,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import NotFoundModel from "../../Components/NotFoundModel";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import SideModal from "../../Components/SideModal";
import SelectProperty from "../../Components/AddTenant/SelectProperty";
import Table from "../../Components/LandlordPortal/Tenant/Table";

const TenantList = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty,
  );
  const properties = useSelector((state) => state.PropertyReducer.property);
  const [isFocused, setIsFocused] = useState(false);
  const [isSelectProperty, setIsSelectProperty] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState();
  const [selectedProperty, setSelectedProperty] = useState(property);
  const query = `propId=${selectedProperty?.id}`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/landlord/list/tenants?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) error = true;
    else {
      setApiData(res?.data);
      setIsFocused(true);
    }
  };

  const getError = () => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);
    return () => clearTimeout(handler);
  }, [selectedProperty, getListMutate]);

  useEffect(() => {
    if (property && !selectedProperty) {
      setSelectedProperty(property);
    }
  }, [property, selectedProperty]);

  const handlePropertySelect = (property) => {
    sessionStorage.removeItem("tenant_active_page");
    setSelectedProperty(property);
  };

  const handleSelectPropertyClose = () => {
    setIsSelectProperty(false);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            {"Occupants"}
            <Underline />
          </BoxTitle>
        </BoxHead>

        <SideModal
          isOpen={isSelectProperty}
          onClose={() => setIsSelectProperty(false)}
        >
          <SelectProperty
            setIsSelectProperty={setIsSelectProperty}
            isSelectProperty={isSelectProperty}
            handleClose={handleSelectPropertyClose}
            getListMutate={getListMutate}
          />
        </SideModal>
     
       
          <FilterTableWrapper>
            <FilterWrapper>
              {/* {isFocused && data && (
                <> */}
                  <div className="flex items-center justify-between w-full gap-3">
   <div className="flex items-center">
                  <Text>
                    Total records:{" "}
                    <span className="font-semibold">
                      {data?.total || 0}
                    </span>
                  </Text>
                </div>
                    <div className="flex gap-2 justify-end items-center ml-auto">
                      <PropertiesFilterDropdown
                        properties={properties}
                        selectedProperty={selectedProperty}
                        onPropertySelect={handlePropertySelect}
                        placeholder="Select Property"
                        className="min-w-[200px] w-full md:w-[220px]"
                      />
                    </div>
                  </div>
                {/* </>
              )} */}
            </FilterWrapper>
             {!error && !isLoading && apiData && (
            <TableWrapper>
              <Table
                apiData={error ? [] : apiData?.length > 0 ? apiData : []}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
              />
              {(error || apiData?.length === 0) && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
              )}
          </FilterTableWrapper>
      
        {(isLoading || isRefetching) && <Loading />}
        {error && !isLoading && <NotFoundModel />}
      </BoxContainer>
    </>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md `;
const Text = tw.p`text-gray-500 text-sm font-normal `;
export default TenantList;
